import React from "react";
import { motion } from "framer-motion";
import { Truck, ShieldCheck, IndianRupee, Award } from "lucide-react";
import { classes } from "./tokens";

/**
 * Wisedrive Promise — gomechanic-style 4-card guarantee row.
 * Pickup-Drop · Genuine Parts · Warranty · Affordable.
 */
const promises = [
  { icon: Truck,        title: "Doorstep Service",        desc: "We pick, service & drop your car. Across 500+ Indian cities. GPS-tracked, fully insured.", tone: "from-blue-50 to-blue-100" },
  { icon: Award,        title: "OEM Genuine Parts",       desc: "100% genuine parts. Box-photo shared on WhatsApp before fitting.",                          tone: "from-blue-50 to-blue-100" },
  { icon: ShieldCheck,  title: "1,000 km Warranty",       desc: "30-day / 1,000 km service warranty on all work — fixed free.",                              tone: "from-green-50 to-green-100" },
  { icon: IndianRupee,  title: "Service in 1 Hr @ Your Doorstep", desc: "Quick turnaround. UPI, Card, Net Banking or Cash — your choice. GST Invoice included.", tone: "from-amber-50 to-amber-100" },
];

const CarServicePromise = () => (
  <section
    className="py-16 lg:py-24 bg-slate-50"
    data-testid="promise-section"
  >
    <div className={classes.container}>
      <div className="text-center mb-12 max-w-2xl mx-auto">
        <span className={classes.overline}>Wisedrive Promise</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-slate-900 leading-tight mt-2">
          Four reasons we're different.
        </h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {promises.map((p, i) => (
          <motion.div
            key={p.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.4, delay: i * 0.08 }}
            className="bg-white rounded-2xl p-5 lg:p-7 flex flex-col items-center text-center gap-3 lg:gap-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all"
          >
            <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${p.tone} inline-flex items-center justify-center shadow-sm`}>
              <p.icon className="h-7 w-7 text-blue-600" strokeWidth={2.2} />
            </div>
            <div className="text-base lg:text-lg font-extrabold text-slate-900 leading-tight">{p.title}</div>
            <p className="text-xs lg:text-sm text-slate-500 leading-relaxed">{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default CarServicePromise;
